import $ from 'jquery';
import { clarify } from '@/domain/services/VueDataProvider';
import Uploader from '@/lib/uploader.js';

export default function () {
	if (typeof standaloneOptions !== 'undefined') {
		// eslint-disable-next-line no-undef
		$.each(standaloneOptions, function (i, uploader) {
			const element = $('#' + uploader.id);

			if (element.length > 0) {
				new Uploader(clarify(uploader.options), element);
			}
		});
	}
}
